import { SVGProps } from "react";

export const SVGIconDashboard = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
    <rect width="14" height="2" rx="1" fill="#222222" />
    <rect y="4" width="14" height="2" rx="1" fill="#222222" />
    <rect y="8" width="14" height="2" rx="1" fill="#222222" />
  </svg>
);
